"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBbvaStore = void 0;
const pinia_1 = require("pinia");
exports.useBbvaStore = (0, pinia_1.defineStore)("bbva", {
    state() {
        return {
            data: null,
            plazo: 24,
            engancheAmount: 0,
            enganchePercentage: 20, // min value
        };
    },
    actions: {},
});
